export default {
  tourist: 'Tourist Visa',
  bussiness_single: 'Business Visa - Single Entry',
  bussiness_multiple: 'Business Visa - Multiple Entry',
  limited_stay: 'Limited Stay Visa',
  socio_culture: 'Socio-Cultural Visa',
  diplomatic: 'Diplomatic / Service Visa',
  journalist: 'Journalist Visa'
};
